import * as React from 'react';

import * as style from './Table.css';

export const Table: React.FC<React.PropsWithChildren<{}>> = props => {
  const { children } = props;

  return <table className={style['table']}>{children}</table>;
};
